import { BaseService } from "./BaseService";
import {
  CatalogTenant,
  CreateTenantDto,
  ListTenantsResponse,
  RegisterTenantWithAdminDto,
  TenantFilter,
  UpdateTenantDto,
  UpdateTenantPaymentsDto,
} from "@/types/tenant-catalog";

function tenantFilterToQueryParams(
  filter: TenantFilter,
): Record<string, string | number | string[]> {
  const params: Record<string, string | number | string[]> = {};

  if (filter.name !== undefined) {
    params.name = filter.name;
  }
  if (filter.status !== undefined) {
    params.status = filter.status;
  }
  if (filter.regionName !== undefined) {
    params.regionName = filter.regionName;
  }
  if (filter.subscriptionPlanId !== undefined) {
    params.subscriptionPlanId = filter.subscriptionPlanId;
  }
  if (filter.createdAfter !== undefined) {
    params.createdAfter = filter.createdAfter.toISOString();
  }
  if (filter.createdBefore !== undefined) {
    params.createdBefore = filter.createdBefore.toISOString();
  }
  if (filter.limit !== undefined) {
    params.limit = filter.limit;
  }
  if (filter.offset !== undefined) {
    params.offset = filter.offset;
  }
  if (filter.sortBy !== undefined) {
    params.sortBy = filter.sortBy;
  }
  if (filter.sortOrder !== undefined) {
    params.sortOrder = filter.sortOrder;
  }

  return params;
}

class CatalogTenantsService extends BaseService {
  private readonly basePath = "/tenants";

  constructor() {
    super();
  }

  createTenant(dto: CreateTenantDto): Promise<CatalogTenant> {
    return this.post<CatalogTenant>(this.basePath, dto);
  }

  registerTenant(dto: RegisterTenantWithAdminDto): Promise<CatalogTenant> {
    return this.post<CatalogTenant>(`${this.basePath}/register`, dto);
  }

  getTenantById(tenantId: string): Promise<CatalogTenant> {
    return this.get<CatalogTenant>(`${this.basePath}/${tenantId}`);
  }

  patchTenant(tenantId: string, dto: UpdateTenantDto): Promise<CatalogTenant> {
    return this.patch<CatalogTenant>(`${this.basePath}/${tenantId}`, dto);
  }

  patchTenantPayments(
    tenantId: string,
    dto: UpdateTenantPaymentsDto,
  ): Promise<void> {
    return this.patch<void>(`${this.basePath}/${tenantId}/payments`, dto);
  }

  async getTenants(query?: TenantFilter): Promise<ListTenantsResponse> {
    const params = query ? tenantFilterToQueryParams(query) : undefined;
    return this.get<ListTenantsResponse>(this.basePath, params);
  }
}

export const catalogTenantsService = new CatalogTenantsService();
